<template>
  <div style="padding: 20px">
    <div style="background-color: #FFFFFF;border-radius: 8px;padding: 24px;max-height: 1160px;overflow-y: auto">
      <div style="display: flex;justify-content: space-between">
        <div>
          <el-input v-model="query.id" placeholder="请输入任务id" style="width: 260px;" />
          <el-input v-model="query.account_id" placeholder="请输入广告主id" style="width: 260px;margin: 0 20px;" />
          <el-input v-model="query.template_id" placeholder="请输入模板id" style="width: 260px" />
          <el-button type="primary" style="margin-left: 15px" @click="getList">搜索</el-button>
        </div>
        <div>
          <el-button type="danger" @click="stop">终止任务</el-button>
          <el-button type="success" @click="add">添加任务</el-button>
        </div>
      </div>
      <div style="border: 1px solid #e6ebf2;border-radius: 6px;margin-top: 20px;border-bottom: none">
        <el-table
          :data="table_data.list"
          :header-cell-style="{ backgroundColor: '#f5f7fa' }"
          style="border-radius: 6px"
          :row-key="getRowKeys"
          max-height="800"
          @select="multipleChoice"
          @select-all="multipleChoice"
        >
          <el-table-column
            v-if="true"
            type="selection"
            width="55"
            :data-index="1"
            :reserve-selection="true"
          />
          <el-table-column prop="id" label="ID">
            <template #header>
              <div style="padding-left: 24px;">ID</div>
            </template>
            <template #default="scope">
              <div style="padding-left: 24px;">{{ scope.row.id }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="total_num" label="计划数量" />
          <el-table-column prop="success_num" label="成功数量" />
          <el-table-column prop="created_at" label="创建时间" />
          <el-table-column prop="job_status" label="执行状态">
            <template slot-scope="scope">
              <el-tag :type="scope.row.job_status === 0 ? 'warning' : scope.row.job_status === 1 ? 'danger': 'success'">{{ scope.row.job_status_text }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="job_status" label="任务状态">
            <template slot-scope="scope">
              <el-tag :type="scope.row.status === 0 ? 'success' : scope.row.status === 1 ? 'danger': 'warning'">{{ scope.row.status_text }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template scope="scope">
              <el-button
                type="primary"
                size="mini"
                @click="linkskip(scope.row)"
              >
                任务执行记录
              </el-button>
            </template>
          </el-table-column>
          <!--          <el-table-column label="操作">
            <template slot-scope="scope">
              <span class="action-btn" style="color: #165DFF" @click="edit(scope.row)">修改</span>
              <span class="action-btn" style="color: #F53F3F" @click="del(scope.row)">删除</span>
            </template>
          </el-table-column>-->
        </el-table>
      </div>
      <pagination-right
        :total="table_data.total"
        @size-change="fetchPageSize"
        @current-change="fetchCurrentPage"
      />
      <el-dialog
        :visible.sync="link_visible"
        title="执行记录"
        width="1600px"
      >
        <div class="app-container">
          <el-card style="box-shadow: none; border: none">
            <div class="top">
              <el-row :gutter="10">
                <el-col :span="4">
                  <el-input
                    v-model="ad_query.job_id"
                    placeholder="请输入任务ID"
                  >
                    <i slot="prefix" class="el-input__icon el-icon-search" />
                  </el-input>
                </el-col>
                <el-button type="primary" @click="searchMpAdvert">搜索</el-button>
                <!-- <el-button
                  type="warning"
                  @click="resetMpAdvertList"
                >重置</el-button> -->
                <el-button
                  type="danger"
                  @click="againMpAdvertList"
                >任务重试</el-button>
              </el-row>
            </div>
            <div class="main">
              <el-table
                v-loading="loading"
                :data="ad_data.list"
                style="width: 100%"
              >
                <el-table-column prop="id" label="记录id" align="center" />
                <el-table-column prop="job_id" label="任务id" align="center" />
                <el-table-column prop="account_id" label="广告主账户" align="center" />
                <el-table-column prop="micro_app_name" label="小程序名称" align="center" />
                <el-table-column prop="project_id" label="项目id" align="center" />
                <el-table-column prop="project_name" label="项目名称" align="center" />
                <el-table-column prop="status_text" label="状态" align="center" />
                <el-table-column
                  prop="fail_reason"
                  label="失败原因"
                  align="center"
                  width="380"
                />
                <el-table-column
                  prop="updated_at"
                  label="更新时间"
                  align="center"
                />
                <el-table-column
                  prop="created_at"
                  label="创建时间"
                  align="center"
                />
              </el-table>
              <pagination-right
                :total="ad_data.total"
                @size-change="adFetchPageSize"
                @current-change="adFetchCurrentPage"
              />
            </div>
          </el-card>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>

import { jobRecordList, jobStop, retryCecord, setupJobList } from '@/api/customer'
import PaginationRight from '@/components/PaginationRight/index.vue'
export default {
  components: { PaginationRight },
  data() {
    return {
      query: {
        page: 1,
        page_size: 10,
        id: '',
        account_id: '',
        template_id: ''
      },
      table_data: {
        list: [],
        total: 0
      },
      job_id: null,
      id: null,
      selectedCodes: [],
      link_visible: false,
      ad_query: {
        page: 1,
        page_size: 10,
        job_id: ''
      },
      ad_data: {
        total: 0,
        list: []
      },
      loading: false,
      account_ids: [],
      zhixingid: ''
    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList() {
      setupJobList(this.query).then(res => {
        console.log(res)
        this.table_data = res.data
      })
    },
    getAdList() {
      jobRecordList(this.ad_query).then(res => {
        console.log(res)
        this.ad_data = res.data
      })
    },
    edit(val) {
    },
    add() {
      this.$router.push('/massiveAdvertisingAD/AdvertisingAddJob/index')
    },
    stop() {
      console.log(this.account_ids)
      this.$confirm('确定终止这些任务吗', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        jobStop({ id: this.account_ids }).then(res => {
          if (res.code === 0) {
            this.$message.success('成功')
          }
        })
      })
    },
    getRowKeys(row) {
      return row.id
    },
    multipleChoice(arr) {
      console.log('arr:', arr)
      this.account_ids = arr.map(item => {
        return item.id
      })
      this.account_item = arr
      console.log(this.account_ids, 11, this.account_item)
    },
    commit() {
    },
    fetchCurrentPage(e) {
      this.query.page = e
      this.getList()
    },
    fetchPageSize(e) {
      this.query.page_size = e
      this.getList()
    },
    linkskip(row) {
      console.log(row)
      this.ad_query.job_id = row.id
      this.getAdList()
      this.link_visible = true
      // this.$router.push({ path: '/tencentAD/copyRecord/job-record', query: { row: row }})
    },
    searchMpAdvert() {
      // eslint-disable-next-line eqeqeq
      if (this.ad_query.job_id == '') {
        this.$message.error('请输入任务ID进行搜索')
        return
      }
      this.ad_query.page = 1
      this.getAdList()
    },
    // 重置广告列表
    resetMpAdvertList() {
      this.ad_query = {
        job_id: '',
        page: 1,
        page_size: 10
      }
      this.getAdList()
    },
    adFetchCurrentPage(e) {
      this.ad_query.page = e
      this.getAdList()
    },
    adFetchPageSize(e) {
      this.ad_query.page_size = e
      this.getAdList()
    },
    againMpAdvertList() {
      console.log(this.job_id)
      // eslint-disable-next-line eqeqeq
      if (this.ad_query.job_id == '') {
        this.$message.error('请输入任务ID进行任务重试')
        return
      }
      if (this.ad_query.job_id && this.ad_query.job_id !== '') {
        retryCecord({ job_id: this.ad_query.job_id }).then(res => {
          if (res.code === 0) {
            this.$message.success('请求成功')
          }
        })
      }
    }
  }
}
</script>

<style scoped>
.header {
  display: flex;
  justify-content: space-between;
}
.main {
  margin-top: 20px;
  video {
    width: 100px;
    height: 100px;
    object-fit: fill;
  }
  .shadowBox {
    display: flex;
    height: 100px;
    align-items: center;
    justify-content: center;
  }
}
.app-container {
  padding: 0px;
}
</style>
